import { useState, useEffect, useContext } from "react";
import {
  Box,
  Flex,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useColorModeValue,
  Stack,
  // Breadcrumb,
  // BreadcrumbItem,
  // BreadcrumbLink,
  Tooltip,
  Center,
  Avatar,
  Text,
  WrapItem,
  Image,
} from "@chakra-ui/react";
// import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { FaDownload } from "react-icons/fa";
import ResetPasswordFormModal from "components/Auth/ResetPasswordFormModal";
import { HamburgerIcon } from "@chakra-ui/icons";
import { appRequest } from "routes";
import BadgeComponent from "../NotificationNavbar/BadgeComponent";
import BadgeMenuComponent from "../NotificationNavbar/BadgeMenuComponent";
import { AppContext } from "AppProvider/AppContext";
import { useHasPermission } from "App/DMRC/components/common/PermissionsFunction/permissiosnFunction";

// const NavLink = ({ children }: { children: ReactNode }) => (
//   <Link
//     px={2}
//     py={1}
//     rounded={"md"}
//     _hover={{
//       textDecoration: "none",
//       bg: useColorModeValue("gray.200", "gray.700"),
//     }}
//     href={"#"}
//   >
//     {children}
//   </Link>
// );

type setActivePage = React.Dispatch<React.SetStateAction<string>>;

export default function Navbar({
  activePage,
  setActivePage,
  displaySidebar,
  setDisplaySidebar,
  setOpenMobileSideDrawer,
}: {
  activePage: string;
  setActivePage: setActivePage;
  displaySidebar: boolean;
  setOpenMobileSideDrawer: any;
  setDisplaySidebar: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  // change password functionality
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };

  // const [data, setData] = useState<notification[]>([]);

  const { companyType } = useContext(AppContext);

  const getUserName = () => {
    return (
      accountDetails?.name ||
      accountDetails?.designation ||
      accountDetails?.username ||
      ""
    );
  };

  const handleLogout = () => {
    localStorage.removeItem("auth-token");
    window.location.reload();
  };

  // const AddBreadCrumItem = (value: string) => {
  //   const page = value;
  //   return (
  //     <BreadcrumbItem>
  //       <BreadcrumbLink
  //         isCurrentPage
  //         href="#"
  //         onClick={() => setActivePage(page)}
  //       >
  //         {value}
  //       </BreadcrumbLink>
  //     </BreadcrumbItem>
  //   );
  // };

  // const BreadCrum = () => {
  //   return (
  //     <Breadcrumb>
  //       <BreadcrumbItem>
  //         <BreadcrumbLink
  //           href="#"
  //           color="gray.400"
  //           onClick={() => setActivePage("Dashboard")}
  //         >
  //           Home
  //         </BreadcrumbLink>
  //       </BreadcrumbItem>
  //       <Box fontWeight="600">{AddBreadCrumItem(activePage)}</Box>
  //     </Breadcrumb>
  //   );
  // };

  // const BreadCrumPrint = () => {
  //   return (
  //     <Breadcrumb fontWeight="700">{AddBreadCrumItem(activePage)}</Breadcrumb>
  //   );
  // };

  //* get notifications
  // const handleGetNotification = async (value: string = "") => {
  //   try {
  //     // Call API to get domain data
  //     const response: any = await appRequest("notification", "get", { value });

  //     // Check if response has data
  //     if (response) {
  //       // If response is an array, set the data state to the array
  //       if (Array.isArray(response)) {
  //         setData(response);
  //       } else {
  //         // If response is not an array, set the data state to an empty array
  //         setData([]);
  //       }
  //     } else {
  //       // If there is an error in response, show toast message with the error message
  //       toast({
  //         title: `Error getting the Notification.`,
  //         description: response.message || "Something went wrong.",
  //         status: "error",
  //         duration: 5000,
  //         isClosable: true,
  //         position: "top-right",
  //       });
  //     }
  //   } catch (error: any) {
  //     // If there is an error in the API call, show toast message with the error message
  //     toast({
  //       title: `Error getting the Notification.`,
  //       description: error.message || "Something went wrong.",
  //       status: "error",
  //       duration: 9000,
  //       isClosable: true,
  //       position: "top-right",
  //     });
  //   }
  // };

  // useEffect(() => {
  //   handleGetNotification();
  // }, []);

  const StataionStatus = useHasPermission("canChangeStationStatus");
  const BapId = useHasPermission("canSeeBapIds");
  const Users = useHasPermission("canCreateUser");

  // download pdf file
  const downloadPDF = () => {
    const pdfURL = "/img/INVS23-24003-4L.pdf";
    const link = document.createElement("a");
    link.href = pdfURL;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = "";
    link.dispatchEvent(new MouseEvent("click"));
  };

  // To get unread notifications count
  const [notificationCount, setNotificationCount] = useState<number>(0);

  // useEffect(() => {
  //   const getNotificationCount = async () => {
  //     try {
  //       const nCount: any = await appRequest(
  //         "notifications",
  //         "getunreadcount",
  //         1
  //       );
  //       if (nCount) {
  //         setNotificationCount(nCount.counts);
  //       } else {
  //         setNotificationCount(0);
  //       }
  //     } catch (err) {}
  //   };
  //   getNotificationCount();
  // }, []);

  const { accountDetails } = useContext(AppContext);

  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        px="6"
        h={{ base: "60px", lg: "80px" }}
        position="sticky"
        zIndex={9}
        top="0px"
        bg={useColorModeValue(
          "gray.1000",
          "gray.500"
        )}
        w={{
          base: "100%",
          lg: displaySidebar
            ? "calc(100% - 6rem)"
            : "100%",
        }}
        ml={{
          base: "unset",
          lg: displaySidebar
            ? "6rem"
            : "0",
        }}
      >
        {/* LEFT SECTION */}

        <Flex alignItems="center">
          {/* MOBILE MENU */}

          <Box
            display={{ lg: "none" }}
            mx={5}
            fontSize="xl"
            cursor="pointer"
            onClick={() => {
              setOpenMobileSideDrawer(true);
            }}
          >
            <HamburgerIcon />
          </Box>

          {/* PAGE TITLE */}

          {/* <Box>
            <Text
              fontSize={{
                base: "lg",
                lg: "2xl",
              }}
              fontWeight="700"
              color="gray.800"
            >
              {activePage}
            </Text>
          </Box> */}
        </Flex>

        {/* CENTER LOGO */}

        <Flex
          justifyContent="center"
          alignItems="center"
          position="absolute"
          left="50%"
          transform="translateX(-50%)"
        >
          <Image
            src="/img/sequelstring.webp"
            alt="logo"
            h={{
              base: "35px",
              lg: "45px",
            }}
            objectFit="contain"
          />
        </Flex>

        {/* RIGHT SECTION */}

        <Flex alignItems={"center"} gap={4}>

          <Stack direction={"row"} spacing={3}>
            {/* <Menu>
              <BadgeComponent count={notificationCount} />
              <MenuList
                alignItems={"center"}
                maxW={{ base: "310px", md: "400px" }}
                mr={{ base: "-3.2rem", md: "unset" }}
                minH="60vh"
                h="100px"
                overflowY="auto"
                className="customScrollBar"
              >
                <BadgeMenuComponent
                  setActivePage={setActivePage}
                  setNotificationCount={setNotificationCount}
                />
              </MenuList>
            </Menu> */}
          </Stack>

          <Stack
            direction={"row"}
            spacing={3}
          >
            <Menu>
              <MenuButton
                as={Button}
                rounded={"full"}
                variant={"link"}
                cursor={"pointer"}
                minW={0}
                textDecoration="none"
                _hover={{
                  border:
                    "0px solid transparent",
                }}
              >
                <WrapItem>
                  <Avatar
                    size="sm"
                    name={getUserName()}
                    src={
                      accountDetails?.profilePhoto
                    }
                    color="white"
                    bg="teal.400"
                  />
                </WrapItem>
              </MenuButton>

              <MenuList
                alignItems={"center"}
                borderRadius="14px"
                p={2}
                minW="240px"
              >
                {/* PROFILE */}

                <Center mt={3}>
                  <WrapItem>
                    <Avatar
                      size="lg"
                      name={getUserName()}
                      src={
                        accountDetails?.profilePhoto
                      }
                      color="white"
                      bg="teal.400"
                    />
                  </WrapItem>
                </Center>

                <Center my={4}>
                  <Flex
                    alignItems="center"
                    flexDirection={"column"}
                    px="15px"
                  >
                    <Tooltip
                      label={getUserName()}
                      hasArrow
                    >
                      <Text
                        fontSize="md"
                        fontWeight="700"
                        textTransform="capitalize"
                        maxW="180px"
                        isTruncated
                      >
                        {getUserName()}
                      </Text>
                    </Tooltip>

                    <Text
                      fontSize="sm"
                      color="gray.500"
                      textTransform="capitalize"
                    >
                      {accountDetails?.role ||
                        ""}
                    </Text>
                  </Flex>
                </Center>

                <MenuDivider />

                {/* MOBILE NAVIGATION */}

                <Box
                  display={{
                    base: "block",
                    lg: "none",
                  }}
                  w="100%"
                >
                  <MenuItem
                    borderRadius="10px"
                    onClick={() =>
                      setActivePage(
                        "Dashboard"
                      )
                    }
                  >
                    Dashboard
                  </MenuItem>

                  <MenuDivider />

                  <MenuItem
                    borderRadius="10px"
                    onClick={() =>
                      setActivePage("Orders")
                    }
                  >
                    Orders
                  </MenuItem>

                  <MenuDivider />

                  <MenuItem
                    borderRadius="10px"
                    onClick={() =>
                      setActivePage("Users")
                    }
                  >
                    Users
                  </MenuItem>

                  <MenuDivider />
                </Box>

                {/* CHANGE PASSWORD */}

                <MenuItem
                  borderRadius="10px"
                  fontWeight="600"
                  onClick={handleOpenModal}
                >
                  Change Password
                </MenuItem>

                <MenuDivider />

                {/* LOGOUT */}

                <MenuItem
                  borderRadius="10px"
                  fontWeight="600"
                  color="red.500"
                  onClick={handleLogout}
                >
                  Logout
                </MenuItem>
              </MenuList>
            </Menu>
          </Stack>
        </Flex>

        {/* MODAL */}

        <ResetPasswordFormModal
          isCurrentPass={true}
          isOpen={isOpen}
          onClose={handleCloseModal}
        />
      </Flex>
    </>
  );
}
